import { RootState } from "../../..";

export const selectRedirectPath = (state: RootState) => state.app.redirectPath;
export const selectDrawerMode = (state: RootState) => state.app.drawerMode;
export const selectSearchQuery = (state: RootState) => state.app.searchQuery;
